// extracted by css-extract-rspack-plugin
export default {"cls1":"AvatarCell-cls1_SYh","cls2":"AvatarCell-cls2_qxc AvatarCell-cls1_SYh","tint-white":"AvatarCell-tint-white_TDq","tint-beige":"AvatarCell-tint-beige_yur"};